import type { StickyFooterProps } from './StickyFooter.typed';
import * as Styled from './StickyFooter.styled';

export const StickyFooter = (props: StickyFooterProps) => {
  const { children } = props;
  return <Styled.StickyFooter>{children}</Styled.StickyFooter>;
};
